import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'delta', 'Delta', [["path",{"d":"M4 20h16l-8 -16l-8 16"}]]);